import { render, staticRenderFns } from "./vesselDetailWrap.vue?vue&type=template&id=6a2dcf96"
import script from "./vesselDetailWrap.vue?vue&type=script&lang=js"
export * from "./vesselDetailWrap.vue?vue&type=script&lang=js"
import style0 from "./vesselDetailWrap.vue?vue&type=style&index=0&id=6a2dcf96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports